import React, { memo } from "react";
import Spacer from "../../Spacer";
import { useTranslation } from "react-i18next";
import { formatValidatedMeasurement } from "../../../utils/results/validatedRanges";

export default memo(function RespiratoryResultRow({
  time,
  date,
  rr,
  hr,
  rrQuality, // "pass"|"fail"|null
  hrQuality, // "good"|"bad"|null
  onClick,
}) {
  const { t } = useTranslation();

  const rrIsBad = rrQuality === "fail";
  const hrIsBad = hrQuality === "bad";

  return (
    <div className="w-full flex flex-col">
      <button
        type="button"
        onClick={onClick}
        className={[
          "w-full text-left py-2 flex items-center gap-4 bg-transparent",
          onClick ? "cursor-pointer" : "cursor-default",
        ].join(" ")}
        disabled={!onClick}
      >
        <div className="shrink-0 w-fit flex flex-col items-center justify-center leading-tight">
          <div>{time}</div>
          <div className="muted-text">{date}</div>
        </div>

        {/* <div className="flex-1 grid grid-cols-2 gap-4 items-center">
         */}
        <div className="flex-1 flex flex-col gap-4 items-center justify-center w-full ">
          {/* RR */}
          <div className="flex flex-col items-center justify-center">
            <p>{t("results.resp.rrLabel", "Respiratory Rate")}</p>
            <div
              className={[
                "title-text",
                rrIsBad ? "text-greyscale-3" : "text-primary",
              ].join(" ")}
            >
              {formatValidatedMeasurement("rr", rr)}
              <span className="muted-text">
                {" "}
                {t("results.resp.rrUnit", "br/min")}
              </span>
            </div>
            {/* reserved line (always takes height) */}
            {/* {(rrIsBad || hrIsBad) && ( */}
            {rrIsBad && (
              <div
                className={[
                  "muted-text text-xs leading-tight",
                  rrIsBad ? "visible" : "invisible",
                ].join(" ")}
              >
                {t("results.quality.low", "Low signal quality")}
              </div>
            )}
          </div>

          {/* HR */}
          {/* <div className="flex flex-col items-center justify-center">
            <p>{t("results.resp.hrLabel", "Heart Rate")}</p>
            <div
              className={[
                "title-text",
                hrIsBad ? "text-greyscale-3" : "text-primary",
              ].join(" ")}
            >
              {fmtInt(hr)}
              <span className="muted-text">
                {t("results.resp.hrUnit", "bpm")}
              </span>
            </div> */}
          {/* reserved line (always takes height) */}
          {/* {(rrIsBad || hrIsBad) && (
              <div
                className={[
                  "muted-text text-xs leading-tight",
                  hrIsBad ? "visible" : "invisible",
                ].join(" ")}
              >
                {t("results.quality.low", "Low signal quality")}
              </div>
            )}
          </div> */}
        </div>
      </button>

      <Spacer />
    </div>
  );
});
